import { Lock } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useEmployeeProfile } from '~/data/employeeProfile';
import { AccountManagementMenu_OnUpdateLegacy } from '~/library/AccountManagementMenu/component';

import { useChangeAccountStatus } from './useChangeAccountStatus';

type Props = AccountManagementMenu_OnUpdateLegacy & {
  open: boolean;
  onClose: () => void;
};

export const ChangeAccountStatus = ({
  open,
  onClose,
  onUpdateLegacy,
}: Props) => {
  const { t } = useTranslation();
  const { profile } = useEmployeeProfile();
  const getTitleWithEmployeeName = useCallback(
    (title) =>
      !!profile ? `${title} - ${profile.firstName} ${profile.lastName}` : title,
    [profile],
  );

  const onSubmitSuccess = useCallback(() => {
    if (!!onUpdateLegacy) {
      onUpdateLegacy(['changeAccountStatus']);
    }
    onClose();
  }, [onUpdateLegacy, onClose]);

  const { onSubmit, status, handleChange } = useChangeAccountStatus({
    onSubmitSuccess,
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <SolaForceDialogTitle onClose={onClose} icon={<Lock />}>
        {getTitleWithEmployeeName(t('laChangeAccountStatus'))}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <FormControl>
          <FormLabel id={'account-status'}>{t('fAccountStatus')}</FormLabel>

          <RadioGroup
            aria-labelledby={'account-status'}
            row
            value={status}
            onChange={handleChange}
          >
            <FormControlLabel
              value="ACTIVE"
              control={<Radio />}
              label={t('laActive')}
            />
            <FormControlLabel
              value="RESET"
              control={<Radio />}
              label={t('laReset')}
            />
            <FormControlLabel
              value="DISABLED"
              control={<Radio />}
              label={t('laDisabled')}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={'secondary'}>
          {t('cancel')}
        </Button>
        <Button onClick={onSubmit}>{t('save')}</Button>
      </DialogActions>
    </Dialog>
  );
};
